var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65 65"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.146 45.932l-14.219-6.094a3.047 3.047 0 00-3.555.876l-6.3 7.693a47.057 47.057 0 01-22.5-22.5l7.693-6.3a3.039 3.039 0 00.876-3.555l-6.085-14.21A3.067 3.067 0 0015.565.077L2.361 3.124A3.047 3.047 0 000 6.093 58.9 58.9 0 0058.907 65a3.047 3.047 0 002.971-2.361l3.047-13.2a3.084 3.084 0 00-1.779-3.5z",
    fill: "currentColor"
  })));
}

export default SvgIconPhone;